<div class="main-container">
  <div class="mdl-container">
    <div class="d-grid mdl-header">
      <div class="center-svg"><img src="assets/svg/name-icon.svg" alt=""></div>
      <div>
        <h4 class="text-semibold">Filtrar presupuestos</h4>
        <h6 class="color-gray" style="font-weight: 400;">Selecciona los criterios para filtrar la vista de presupuestos.</h6>
      </div>
      <div>
        <h3 class="color-gray text-semibold">
          <div class="center-svg">
            <img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt="">
          </div>
        </h3>
      </div>
    </div>

    <form>
      <div class="filter-section">
        <label class="section-title">Estado de sincronización</label>
        <div class="filter-options">
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.allSyncStatus" name="allSyncStatus" (change)="toggleAllSyncStatus()">
            <span class="crm-checkbox-custom"></span>
            Todos los estados
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.syncStatus.sincronizado" name="sincronizado" (change)="onSyncStatusChange()">
            <span class="crm-checkbox-custom"></span>
            Sincronizados
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.syncStatus.noSincronizado" name="noSincronizado" (change)="onSyncStatusChange()">
            <span class="crm-checkbox-custom"></span>
            No sincronizados
          </label>
        </div>
      </div>

      <div class="filter-section">
        <label class="section-title">Rango de precio total</label>
        <div class="options-row">
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="priceRange" [(ngModel)]="filters.priceRange" value="all">
            <span class="crm-radio-custom"></span>
            Todos los precios
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="priceRange" [(ngModel)]="filters.priceRange" value="0-100000">
            <span class="crm-radio-custom"></span>
            $0 - $100.000
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="priceRange" [(ngModel)]="filters.priceRange" value="100001-500000">
            <span class="crm-radio-custom"></span>
            $100.001 - $500.000
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="priceRange" [(ngModel)]="filters.priceRange" value="500001-1000000">
            <span class="crm-radio-custom"></span>
            $500.001 - $1.000.000
          </label>
          <label class="crm-radio-label">
            <input type="radio" class="crm-radio" name="priceRange" [(ngModel)]="filters.priceRange" value="1000001+">
            <span class="crm-radio-custom"></span>
            Más de $1.000.000
          </label>
        </div>
      </div>

      <div class="filter-section">
        <label class="section-title">Fecha de caducidad</label>
        <div class="filter-options">
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.allDateRanges" name="allDateRanges" (change)="toggleAllDateRanges()">
            <span class="crm-checkbox-custom"></span>
            Todas las fechas
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.dateRanges.proximos7dias" name="proximos7dias" (change)="onDateRangeChange()">
            <span class="crm-checkbox-custom"></span>
            Próximos 7 días
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.dateRanges.proximos30dias" name="proximos30dias" (change)="onDateRangeChange()">
            <span class="crm-checkbox-custom"></span>
            Próximos 30 días
          </label>
          <label class="crm-checkbox-label">
            <input type="checkbox" class="crm-checkbox" [(ngModel)]="filters.dateRanges.vencidos" name="vencidos" (change)="onDateRangeChange()">
            <span class="crm-checkbox-custom"></span>
            Vencidos
          </label>
        </div>
      </div>

      <hr style="margin-top: 24px;">

      <div class="filter-actions">
        <button type="button" class="btn btn-primary-outline" (click)="closeMdl()">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="applyFilters()">Aplicar filtros</button>
      </div>
    </form>
  </div>
</div>